import { defineComponent as _defineComponent } from 'vue'
import {CustomerAccount, TableViewCustomer} from '@/models/dto'
import customerAccount from '@/services/customerAccount'
import OrganizationTeamEditUser from '@/components/OrganizationTeamEditUser.vue'
import alert from '@/store/modules/alert'
import {computed, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationTeamMoreActions',
  props: {
    row: null,
    team: null,
    enableUrmRoles: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  row: TableViewCustomer,
  team: CustomerAccount,
  enableUrmRoles: boolean
};



const sending = ref<boolean>(false)
const sent = ref<boolean>(false)
const isEditing = ref<boolean>(false)

const isSignedUp = computed(() => {
  return props.row.isSignedUp
})

const resendInvite = async (): Promise<void> => {
  try {
    if (isSignedUp.value) {
      return
    }
    sending.value = true
    await customerAccount.resendInvite({ email: props.row.email })
    sent.value = true
    alert.add({
      text: 'Successfully sent email invite.',
      color: 'primary',
      title: 'Success',
      dismissible: true,
    })
  } catch (e) {
    sent.value = false
    alert.add({
      text: 'Error sending invite. Please try again later.',
      color: 'error',
      title: 'Error',
      dismissible: true,
    })
  }
  sending.value = false
}


return { __sfc: true,props, sending, sent, isEditing, isSignedUp, resendInvite, OrganizationTeamEditUser }
}

})